import React, { useEffect, useState, forwardRef, useImperativeHandle, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { DocViewer } from '../DocViewers';
import { getEPOInvoice } from '../../../../api/epo';
import DocsNavControls from '../Tabs/DocsNavControls';

function DocViewerModal({ invoice, onClose, invoiceDetails, setInvoice }) {
  const [localInvoiceData, setLocalInvoiceData] = useState();
  const [fileType, setFileType] = useState();
  const [fileBuffer, setFileBuffer] = useState();
  const childRef = React.createRef();
  const [pageNo, setPageNo] = useState(null);
  const totalDocs = invoiceDetails?.length;
  useEffect(() => {
    setLocalInvoiceData(invoice);
    if (invoice?.invoiceId) {
      getEPOInvoice(invoice.invoiceId).then((res) => {
        setFileBuffer(Buffer.from(res[0].invoice.data));
        setFileType(invoice.filename.split('.').slice(-1)[0].toLowerCase());
      });
    } else {
      setFileBuffer();
      setFileType();
    }
  }, [invoice]);
  useEffect(() => {
    if (childRef.current) {
      const pageNumber = childRef.current.getPageNo() + 1;
      setPageNo(pageNumber);
    }
  }, [localInvoiceData?.invoiceId]);

  const handleDownloadFile = () => {
    if (!fileBuffer) return;
    const fileURL = window.URL.createObjectURL(new Blob([fileBuffer]));
    const a = document.createElement('a');
    console.log('file url is', fileURL);
    document.body.appendChild(a);
    a.href = fileURL;
    a.download = localInvoiceData?.filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(a);
    }, 0);
  };

  if (!localInvoiceData?.invoiceId) return null;

  const handleNext = () => {
    if (childRef.current) {
      childRef.current.loadNextDoc();
      setPageNo((prevNo) => prevNo + 1);
    }
  };

  const handlePrev = () => {
    if (childRef.current) {
      childRef.current.loadPrevDoc();
      setPageNo((prevNo) => prevNo - 1);
    }
  };

  return (
    <Modal show={localInvoiceData?.invoiceId} centered contentClassName="editModal" dialogClassName="superwide-modal">
      <Modal.Header>
        <Modal.Title>Viewing: {localInvoiceData?.filename}</Modal.Title>
        {
          <DocsNavControls
            dowloadFile={handleDownloadFile}
            handleNext={handleNext}
            pageNo={pageNo}
            handlePrev={handlePrev}
            onClose={onClose}
            totalDocs={totalDocs}
          />
        }
      </Modal.Header>
      <div className="flex-grow-1 d-flex flex-column">
        <Modal.Body className="flex-grow-1">
          <EpoInvoiceSummary
            invoiceId={localInvoiceData?.invoiceId}
            setInvoice={setInvoice}
            ref={childRef}
            invoiceDetails={invoiceDetails}
            fileBuffer={fileBuffer}
            setFileBuffer={setFileBuffer}
          />
        </Modal.Body>
        <Modal.Footer
          class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light align-items-center"
          style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
        >
          <div className="d-flex gap-2 align-items-center">
            <span className="bold" style={{ fontSize: '16px' }}>
              Totals:
            </span>
            <span className="badge bg-success" style={{ fontSize: '14px' }}>
              Gross Mass: {localInvoiceData.invGrossMass ?? 0}kg
            </span>
            <span className="badge bg-success" style={{ fontSize: '14px' }}>
              Net Mass: {localInvoiceData.invNetMass ?? 0}kg
            </span>
            <span className="badge bg-success" style={{ fontSize: '14px' }}>
              Value: {(localInvoiceData.invValue ?? 0).toFixed(2)}
            </span>
            <span className="badge bg-success" style={{ fontSize: '14px' }}>
              # Rows: {localInvoiceData.itemRows ?? 0}
            </span>
          </div>
          <div className="flex-grow-1" />
          <button
            type="button"
            class="cancel-button"
            onClick={onClose}
            style={{ display: 'flex', borderRadius: '10px' }}
          >
            Cancel
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}
const EpoInvoiceSummary = forwardRef((props, ref) => {
  const { invoiceId, invoiceDetails, fileBuffer, setFileBuffer, setInvoice } = props;
  //const { fileBuffer, setBuffer, cycle } = useContext(EpoJobDetailContext);
  const [curDocIndex, setCurDocIndex] = useState(invoiceId || null);

  const invoiceIndex = invoiceDetails?.findIndex((item) => item.invoiceId === invoiceId);

  const [curIndex, setCurIndex] = useState(() => invoiceIndex);
  const [pageNo, setPageNo] = useState(curIndex);
  const totalDocs = invoiceDetails?.length;

  useEffect(() => {
    if (curDocIndex) {
      getEPOInvoice(curDocIndex).then((res) => {
        setFileBuffer(Buffer.from(res[0].invoice.data));
      });
    }
  }, [curDocIndex]);

  const loadNextDoc = () => {
    if (curIndex < totalDocs) {
      setCurIndex((preIndex) => preIndex + 1);
      setCurDocIndex(invoiceDetails[curIndex + 1]['invoiceId']);
      setPageNo((preNo) => preNo + 1);
      setInvoice(invoiceDetails[curIndex + 1]);
    }
  };

  const loadPrevDoc = () => {
    if (curIndex > 0) {
      setCurIndex((prevIndex) => prevIndex - 1);
      setCurDocIndex(invoiceDetails[curIndex - 1]['invoiceId']);
      setPageNo((prevPageNo) => prevPageNo - 1);
      setInvoice(invoiceDetails[curIndex - 1]);
    }
  };

  const getPageNo = () => {
    return pageNo;
  };

  // Expose the function to the parent component using useImperativeHandle
  useImperativeHandle(ref, () => ({
    loadNextDoc,
    loadPrevDoc,
    dowloadFile,
    getPageNo,
  }));

  const dowloadFile = () => {
    if (!fileBuffer) return;
    const fileURL = window.URL.createObjectURL(new Blob([fileBuffer]));
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = fileURL;
    a.download = invoiceDetails[curIndex].filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(a);
    }, 0);
  };

  const filetype = invoiceDetails[curIndex].filename.split('.').slice(-1)[0].toLowerCase();

  return (
    <section className="p-2 d-flex flex-column justify-content-around gap-2 mt-3">
      <div
        className="p-3 rounded-3"
        style={{ height: '540px', overflowY: 'auto', border: '2px solid hsl(0, 0%, 75%)', cursor: 'pointer' }}
      >
        <div className="invoice-preview">
          <DocViewer fileBuffer={fileBuffer} filetype={filetype} />
        </div>
      </div>
    </section>
  );
});

export default DocViewerModal;
